import { render, staticRenderFns } from "./principal.vue?vue&type=template&id=308ef5a0&scoped=true"
import script from "./principal.vue?vue&type=script&lang=js"
export * from "./principal.vue?vue&type=script&lang=js"
import style0 from "./principal.vue?vue&type=style&index=0&id=308ef5a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308ef5a0",
  null
  
)

export default component.exports